export default __webpack_public_path__ + "static/media/oceancourier.099a883f.svg";